import { motion } from "framer-motion";
import { Logo } from "./Logo";
import { useT } from "@/i18n";
import { NavA } from "./Nav";
import { openCookieSettings } from "@/lib/consent";
import { SocialLinks } from "./Social";

// Company data shown in the footer of every page.
export const COMPANY = {
  name: "EMMA INDUSTRIE srl",
  legal: "Via Angelo Masini, 12/14 · 40126 Bologna (BO)",
  plant: "Via Michele Utveggio, 7 · Z.I. San Cataldo Scalo · 93100 Caltanissetta (CL)",
  vat: "IT03694561204",
};

const NAV = [["Prodotti", "#prodotti", "footer.prodotti"], ["Progetti", "#progetti", "footer.progetti"], ["Chi siamo", "/chi-siamo", "footer.chi-siamo"], ["Calcolatori", "/calcolatori", "nav.calcolatori"], ["Contatti", "#contatti", "footer.contatti"], ["Lavora con noi", "/lavora-con-noi", "footer.careers"], ["Mappa del sito", "/mappa-del-sito", "map.title"]];
const LEGAL = [["Privacy policy", "/privacy-policy", "footer.privacy"], ["Cookie policy", "/cookie-policy", "ck.policy"], ["Termini e condizioni", "/termini-e-condizioni", "footer.terms"]];
const slug = (to) => to.replace(/[^a-z-]/g, "");
const Head = ({ children }) => <p className="mb-4 font-mono text-xs uppercase tracking-[0.25em] text-[#121110]/70">{children}</p>;

export const Footer = () => {
  const t = useT();
  const linkCls = "tap nav-link block text-left text-sm";
  return (
  <footer className="overflow-hidden bg-[#C26D38] px-5 pt-16 text-[#121110] sm:px-8" data-testid="site-footer">
    <div className="mx-auto max-w-[1500px]">
      <div className="grid gap-12 border-b border-[#121110]/20 pb-12 sm:grid-cols-2 lg:grid-cols-12">
        <div className="flex flex-col gap-5 lg:col-span-3">
          <Logo tone="dark" className="h-14" />
          <p className="max-w-xs text-sm leading-relaxed">{t("footer.tagline", "Legno lamellare, X-LAM e strutture in legno. Dal 1905.")}</p>
          <SocialLinks id="footer-social" btnClass="border-[#121110]/40" />
        </div>
        <div className="lg:col-span-4" data-testid="footer-company">
          <Head>{t("footer.company", "Dati societari")}</Head>
          <address className="space-y-1.5 text-sm not-italic leading-relaxed">
            <p className="font-semibold">{COMPANY.name}</p>
            <p>{t("footer.legalSeat", "Sede legale")}: {COMPANY.legal}</p>
            <p>{t("footer.plant", "Sede operativa")}: {COMPANY.plant}</p>
            <p>{t("footer.vat", "P.IVA e C.F.")}: {COMPANY.vat}</p>
            <p><a href="tel:+390510830043" className="nav-link">Tel. 051 0830043</a> · <a href="https://wa.me/393803758249" target="_blank" rel="noopener noreferrer" className="nav-link">WhatsApp 380 3758249</a></p>
            <p><a href="mailto:info@emmaindustrie.it" className="nav-link">info@emmaindustrie.it</a></p>
          </address>
        </div>
        <nav className="lg:col-span-3" aria-label={t("footer.navH", "Navigazione")}>
          <Head>{t("footer.navH", "Navigazione")}</Head>
          <ul className="space-y-2.5">
            {NAV.map(([l, to, k]) => <li key={to}><NavA to={to} className={linkCls} data-testid={`footer-link-${slug(to)}`}>{t(k, l)}</NavA></li>)}
          </ul>
        </nav>
        <nav className="lg:col-span-2" aria-label={t("footer.legalH", "Note legali")}>
          <Head>{t("footer.legalH", "Note legali")}</Head>
          <ul className="space-y-2.5">
            {LEGAL.map(([l, to, k]) => <li key={to}><NavA to={to} className={linkCls} data-testid={`footer-link-${slug(to)}`}>{t(k, l)}</NavA></li>)}
            <li><button type="button" onClick={openCookieSettings} className={linkCls} data-testid="footer-cookie-settings">{t("ck.settings", "Preferenze cookie")}</button></li>
          </ul>
        </nav>
      </div>
      <p className="py-6 font-mono text-xs uppercase tracking-[0.2em]" data-testid="footer-copyright">© {new Date().getFullYear()} {COMPANY.name} · P.IVA {COMPANY.vat} · {t("footer.rights", "Tutti i diritti riservati")}</p>
      <motion.p
        initial={{ y: "40%" }}
        whileInView={{ y: "0%" }}
        viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
        className="select-none text-center font-display text-[30vw] font-extrabold lowercase leading-[0.78] tracking-[-0.06em]"
        style={{ fontStretch: "125%" }}
        aria-hidden="true"
      >
        emma
      </motion.p>
    </div>
  </footer>
  );
};
